<template>
  <div class="configurator-page-filter-group 
      configurator-page-filter-group--grid 
      configurator-page-filter-group--products"
  >
    <h3 class="heading" id="filter-group-products">{{ pointStore.products.heading }}</h3>
    <div
        class="configurator-page-filter-group__item"
        :class="[product.disabled ? 'configurator-page-filter-group__item--disabled' : 
        '', product.selected ? 'configurator-page-filter-group__item--selected' : '']"
        aria-labelledby="filter-group-products"
        v-on:click="toggleProduct(product)"
        v-for="product in pointStore.products.list"
        v-bind:key="product.id">
      <img :src="product.image" :alt="product.name"/>
      <p>{{ product.name }}</p>
    </div>
  </div>
</template>

<script setup>
import {usePointStore} from '../store/store';

const pointStore = usePointStore();

const emit = defineEmits([
  'clicked',
  'toggleProduct'
]);

function toggleProduct(product) {
  emit('clicked', product);
  emit('toggleProduct', product);
}


</script>